import { React, useState, useEffect } from 'react';
import './loading-spinner.scss';

export const LoadingSpinner = ({
  status = true,
  name = 'Item',
  wrap = true,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(status);
  }, [status]);

  return (
    <div
      className={`loading-spinner-component${wrap ? ' wrapper' : ''}${
        !isLoading ? ' screen-reader' : ''
      }`}
    >
      <div
        className={`loading-spinner`}
        aria-busy={isLoading ? 'true' : 'false'}
        aria-live="polite"
        aria-atomic
      >
        <div className="circle"></div>
        <div className="spinner">
          <svg>
            <circle cx="25" cy="10" r="7" strokeWidth="3" />
          </svg>
        </div>
        <span className="screen-reader" role="alert">
          {isLoading ? `Loading ${name} ... ` : `Loaded ${name}`}
        </span>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {};
